import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const FeatureFlagContext = createContext({ flags: {}, loading: true, isEnabled: () => true });

export const useFeatureFlags = () => useContext(FeatureFlagContext);

export const FeatureFlagProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setFlags({});
      setLoading(false);
      return;
    }
    const fetchFlags = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/feature-flags/status`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
          credentials: 'include',
        });
        if (res.ok) {
          const data = await res.json();
          setFlags(data.flags || {});
        }
      } catch (e) {
        console.error('Failed to fetch feature flags:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchFlags();
  }, [isAuthenticated]);

  const isEnabled = (flagId) => {
    if (flags[flagId] === undefined) return true;
    return flags[flagId];
  };

  return (
    <FeatureFlagContext.Provider value={{ flags, loading, isEnabled }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
